// src/careComponents/utils/roomType.js

/** 
 * Returns:
 *  - true  => shared
 *  - false => private
 *  - null  => unknown / not specified
 */
export function isSharedFromRoomType(roomType) {
  if (roomType == null) return null;

  // First handle enum values exactly
  const upper = String(roomType).trim().toUpperCase();
  if (upper === "PRIVATE") return false;
  if (upper === "SHARED") return true;

  // Fallback to label matching (case-insensitive)
  const t = upper.toLowerCase();

  const PRIVATE = new Set(["private", "single", "studio", "suite", "master"]);
  const SHARED = new Set(["shared", "double", "triple", "semi-private", "semi private"]);

  if (PRIVATE.has(t)) return false;
  if (SHARED.has(t)) return true;

  return null; // unrecognized
}

/** Map free-text or enum-ish strings to "PRIVATE" | "SHARED" | null */
export function toEnumRoomType(v) {
  const u = String(v ?? "").trim().toUpperCase();
  if (u === "PRIVATE" || u === "SHARED") return u;

  // map common free-text to enum
  if (["PRIVATE", "SINGLE", "STUDIO", "SUITE", "MASTER"].includes(u)) return "PRIVATE";
  if (["SHARED", "DOUBLE", "TRIPLE", "SEMI-PRIVATE", "SEMI PRIVATE"].includes(u)) return "SHARED";

  return null;
}

/** Return human label "Private" | "Shared" | "" */
export function toLabelRoomType(v) {
  const e = toEnumRoomType(v);
  return e === "PRIVATE" ? "Private" : e === "SHARED" ? "Shared" : "";
}
